<div class="grid grid-cols-12">
  <div
    class="col-span-12 bg-gray-200 p-6"
    [ngClass]="{
      'md:col-span-8!': showOptions
    }">
    <div
      class="rounded-border bg-white p-6"
      [ngClass]="{
        'pr-0': showOptions
      }">
      <canvas #chartRef>{{ chart() }}</canvas>
    </div>
  </div>
  <div *ngIf="showOptions" class="col-span-12 flex flex-col gap-6 p-6 md:col-span-4">
    <div class="flex flex-col gap-2">
      <label class="text-gray-600" htmlFor="groupByOption">{{ 'search.chart.groupByOption.label' | translate }}</label>
      <p-select
        id="groupByOption"
        appendTo="body"
        [options]="chartOptions?.groupByOptions"
        [ngModel]="currentChartOptions?.groupByOption"
        optionLabel="label"
        [style]="{ width: '100%' }"
        (onChange)="changeChartOptions('groupByOption', $event)"></p-select>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-gray-600" htmlFor="xaxisOption">{{ 'search.chart.xAxisOption.label' | translate }}</label>
      <p-select
        id="xaxisOption"
        appendTo="body"
        [options]="chartOptions?.xaxisOptions"
        [ngModel]="currentChartOptions?.xaxisOption"
        optionLabel="label"
        [style]="{ width: '100%' }"
        (onChange)="changeChartOptions('xaxisOption', $event)"></p-select>
    </div>
    <div *ngIf="currentChartOptions.xaxisOption?.requiresInterval" class="flex flex-col gap-2">
      <label class="text-gray-600" htmlFor="xaxisInterval">{{ 'search.chart.xAxisInterval.label' | translate }}</label>
      <p-select
        id="xaxisInterval"
        appendTo="body"
        [options]="intervalOptions"
        [ngModel]="currentChartOptions?.xaxisInterval.value"
        [style]="{ width: '100%' }"
        (onChange)="changeChartInterval('xaxisInterval', $event)">
        <ng-template pTemplate="item" let-item>
          {{ 'search.chart.interval.' + item?.label | translate }}
        </ng-template>
        <ng-template pTemplate="selectedItem" let-selectedItem>
          {{ 'search.chart.interval.' + selectedItem?.label | translate }}
        </ng-template>
      </p-select>
    </div>
  </div>
</div>
